import type { PropsWithChildren } from 'react'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useLocation } from 'react-router-dom'

import HeadData from 'components/Common/HeadData'
import ModalProvider from 'contexts/ModalProvider'
import useDidChange from 'hooks/useDidChange'
import TourProvider from 'tripPlanner/components/OnboardingTour/TourProvider'
import { DEFAULT_TRIP_IMAGE } from 'tripPlanner/config'
import TripSearchProvider from 'tripPlanner/contexts/Search/TripSearchProvider'
import ViewContextProvider from 'tripPlanner/contexts/View/ViewContextProvider'
import { ViewStateActions } from 'tripPlanner/contexts/View/ViewState'
import useViewState from 'tripPlanner/hooks/View/useViewState'

interface Props extends PropsWithChildren<{}> {}

function RootWrapper({ children }: Props) {
  const intl = useIntl()
  const location = useLocation()
  const { state: viewState, dispatch: viewDispatch } = useViewState()

  const locationChanged = useDidChange(location)

  useEffect(() => {
    if (viewState.isModalOpen && locationChanged) {
      viewDispatch({
        type: ViewStateActions.MODAL_CLOSE,
      })
    }
  }, [viewState.isModalOpen, viewDispatch, locationChanged])

  return (
    <TripSearchProvider>
      <ViewContextProvider dispatch={viewDispatch} state={viewState}>
        <ModalProvider>
          <ModalProvider>
            <TourProvider>
              <HeadData
                title={intl.formatMessage({
                  id: 'MAXLEEnndkp71h-tfxOx',
                  defaultMessage: 'Trip Planner',
                  description: 'Page title for the trip planner section shown in browser tab and search results',
                })}
                description={intl.formatMessage({
                  id: 's4adP7LVQlJdZcpOe6KX',
                  defaultMessage: 'Easily plan your perfect trip, all in one place',
                  description: 'Meta description for the trip planner page shown in search engine results',
                })}
                imageUrl={DEFAULT_TRIP_IMAGE}
              />
              {children}
            </TourProvider>
          </ModalProvider>
        </ModalProvider>
      </ViewContextProvider>
    </TripSearchProvider>
  )
}

export default RootWrapper
